import { useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { EnvelopeIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { CheckCircle } from "feather-icons-react";

const navigation = [
  { name: "Kronos Secure", href: "/kronos-secure" },
  { name: "Kronos Certified", href: "/kronos-certified" },
  { name: "Företagsannonsering", href: "/foretagsannonsering" },
  { name: "Marknadsföring", href: "/marknadsforing" },
  { name: "Integritetspolicy", href: "/integritetspolicy" },
  { name: "Användarvillkor", href: "/anvandarvillkor" },
];

const UnSubscribe = ({ siteLogo }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed inset-x-0 top-0 z-50 bg-white shadow">
        <nav className="flex items-center justify-between p-6 lg:px-8">
          <a href="/" className="flex items-center -m-1.5 p-1.5">
            <span className="sr-only">Krono</span>
            <img
              alt="Krono Logo"
              src={siteLogo}
              className="h-6 w-auto rounded-md"
            />
          </a>

          <div className="flex lg:hidden">
            <button
              type="button"
              className="p-2.5 text-gray-700 rounded-md"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>

          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-semibold text-gray-900 hover:underline"
              >
                {item.name}
              </a>
            ))}
          </div>
        </nav>

        {/* Mobile menu */}
        <Dialog
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
          className="lg:hidden"
        >
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full max-w-sm bg-white px-6 py-6 overflow-y-auto shadow-lg">
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="p-2.5 text-gray-700 rounded-md"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 space-y-2">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      {/* Main Content */}
      <main className="min-h-screen bg-white flex flex-col items-center pt-20 px-6 sm:px-8 lg:px-16">
        {/* Icon */}
        <div className="bg-black rounded-full p-6 mb-8">
          <CheckCircle className="h-16 w-16 text-white" />
        </div>

        {/* Main message */}
        <div className="text-center max-w-md">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-poppins text-black">
            Tack!
          </h2>
          <p className="text-gray-700 mb-4 font-poppins">
            Du har nu avregistrerats från våra e-postutskick.
          </p>
          <p className="text-gray-500 text-sm font-poppins flex items-center justify-center gap-2">
            Du kommer inte längre att få nyheter, erbjudanden eller
            uppdateringar från oss.
          </p>
        </div>

        {/* Unsplash illustration */}
        <div className="mt-12">
          <img
            src="https://images.pexels.com/photos/5426403/pexels-photo-5426403.jpeg"
            alt="Minimal illustration"
            className="w-64 md:w-80 rounded-xl shadow-lg object-cover"
          />
        </div>
      </main>
    </div>
  );
};

export default UnSubscribe;
